import { ThemeProvider } from './contexts/ThemeContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './pages/About';
import Services from './pages/Services';
import Target from './pages/Target';
import JoinAdventure from './components/JoinAdventure';
import Values from './pages/Values';
import Contact from './pages/Contact';
import Footer from './components/Footer';

function AppContent() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200">
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <main>
              <Hero />
              <JoinAdventure />
            </main>
            <Footer />
          </>
        } />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/target" element={<Target />} />
        <Route path="/values" element={<Values />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;